// extracted by mini-css-extract-plugin
export default {"modal":"Modal_modal__yEgVW","modal__inner":"Modal_modal__inner__80ga1"};